import { Box, CardContent, Typography } from '@mui/material'
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'

/**
 * Componente KPI reutilizable
 * para mostrar indicadores clave
 * @param {string} title - Título del KPI
 * @param {string} subtitle - Descripción del KPI
 * @param {string|number} value - Valor numérico
 * @param {string} color - Color del texto
 * @param {string} backgroundColor - color de fondo de tarjeta
 * @param {string} id - ID del elemento HTML
 * @param {string} cssClass - Clase CSS personalizada
 * @param {{xs?: number, sm?: number, md?:number}} size - Tamaños responsive según el breakpoint
 *
 */

const DEFAULT_SIZE = { xs: 12, sm: 6, md: 2 }

const Kpi = ({ title, subtitle, value, color, backgroundColor, id, cssClass, size, sx }) => {
  const theme = useTheme()

  return (
    <Box size={size || DEFAULT_SIZE} sx={{ width: 220, flexShrink: 0, ...sx }}>
      <Card
        id={id}
        className={cssClass}
        sx={{
          color: color || theme.palette.primary.main,
          backgroundColor: backgroundColor || theme.palette.background.paper,
          height: '100%',
        }}
      >
        <CardContent>
          <Typography
            variant="subtitle1"
            sx={{
              opacity: 0.9,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              minHeight: '40px',
            }}
          >
            {title}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 'bold', my: 1 }}>
            {value ?? '-'}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {subtitle}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}

export default Kpi
